import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Star,
  Quote,
  ArrowRight,
  MessageCircle,
} from "lucide-react";
import { Button } from "../components/ui/button";
import PageHero from "../components/layout/PageHero";
import { photoTestimonials, siteInfo } from "../mock/data";

// -------------------- Page --------------------

export default function Testimonials() {
  const [tab, setTab] = useState("photo");

  return (
    <main>
      <PageHero
        eyebrow="Success Stories"
        title="Real students,"
        accent="real victories."
        description="Hear from our students who turned their study-abroad dreams into reality with SNZ Education."
        breadcrumbs={["Testimonials"]}
      />

      {/* Google testimonials */}
      {tab === "photo" && (
        <section className="py-10 lg:py-14 bg-brand-soft">
          <div className="max-w-7xl mx-auto px-5 lg:px-8">
            <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
              <div>
                <span className="text-xs font-bold uppercase tracking-[0.2em] text-amber-600">
                  Google Reviews
                </span>
                <h2 className="text-3xl lg:text-4xl font-extrabold mt-2 text-stone-900 leading-tight">
                  Loved by students everywhere
                </h2>
              </div>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {photoTestimonials.map((t) => {
                const initials = (t.name || "")
                  .split(" ")
                  .filter(Boolean)
                  .map((part) => part[0])
                  .join("")
                  .slice(0, 2)
                  .toUpperCase();

                return (
                  <div
                    key={t.name}
                    className="bg-white border border-stone-200 rounded-3xl p-6 card-lift relative"
                  >
                    <Quote className="absolute top-5 right-5 w-7 h-7 text-stone-100" />
                    <div className="flex items-center gap-1 mb-3">
                      {[...Array(t.rating)].map((_, i) => (
                        <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                      ))}
                    </div>
                    <p className="text-stone-700 leading-relaxed text-[14px]">&ldquo;{t.quote}&rdquo;</p>
                    <div className="flex items-center gap-3 mt-5 pt-5 border-t border-stone-100">
                      <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[#0f5e54] text-white font-semibold text-sm">
                        {initials || "ST"}
                      </div>
                      <div className="min-w-0">
                        <div className="font-bold text-stone-900 truncate">{t.name}</div>
                        <div className="text-xs text-stone-500">{t.tag}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}

      {/* CTA */}
      <section className="py-16">
        <div className="max-w-5xl mx-auto px-5 lg:px-8">
          <div className="bg-[#0f5e54] text-white rounded-[2rem] p-10 lg:p-12 text-center relative overflow-hidden">
            <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-amber-400/20 blur-3xl" />
            <div className="relative">
              <h2 className="text-3xl lg:text-4xl font-extrabold">
                Be our next <span className="text-amber-300">success story</span>
              </h2>
              <p className="mt-4 text-emerald-100/90 max-w-xl mx-auto">
                Join hundreds of students who trusted SNZ Education with their global ambitions.
              </p>
              <div className="mt-7 flex flex-wrap items-center justify-center gap-4">
                <Link to="/contact">
                  <Button className="rounded-full bg-amber-400 hover:bg-amber-500 text-stone-900 font-semibold h-12 px-7">
                    Talk to an Expert <ArrowRight className="ml-2 w-4 h-4" />
                  </Button>
                </Link>
                <a href={siteInfo.whatsapp} target="_blank" rel="noreferrer">
                  <Button
                    variant="outline"
                    className="rounded-full bg-white/10 border-white/30 text-white hover:bg-white hover:text-[#0f5e54] h-12 px-7 font-semibold"
                  >
                    <MessageCircle className="mr-2 w-4 h-4" /> Contact on WhatsApp
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

    </main>
  );
}
